import MuiTooltip from '@mui/material/Tooltip'
import styled from 'styled-components'

const TooltipBase = ({ className, classes, ...props }) => {
  const popperClassName = [classes?.popper, className].filter(Boolean).join(' ')

  return (
    <MuiTooltip
      {...props}
      classes={{
        ...classes,
        popper: popperClassName,
      }}
    />
  )
}

export const TooltipStyled = styled(TooltipBase)`
  & .MuiTooltip-tooltip {
    padding: 4px 12px;
    border-radius: 4px;
    background: var(--t-tooltip-bg);
    color: var(--t-tooltip-text);
    box-shadow: -1px 2px 9px 0 var(--t-tooltip-shadow-color);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  & .MuiTooltip-arrow {
    color: var(--t-tooltip-bg);
  }
`
